import React from 'react';

const Referral = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.15 22.1" {...props}>
    <title>referral</title>
    <path
      className="cls-1"
      d="M18.9,14.45l-.7.7,3,3H8.7v1H21.2l-3.1,3.1.7.7,4.3-4.3Z"
      transform="translate(-0.95 -0.9)"
    />
    <path
      className="cls-1"
      d="M18.8,6.55A3,3,0,0,0,20,4.1,3.08,3.08,0,0,0,16.9,1a3.12,3.12,0,0,0-3.1,3.1,3.22,3.22,0,0,0,1.25,2.5,5.81,5.81,0,0,0-2.8,2.1,6.9,6.9,0,0,0-2.1-1,3.61,3.61,0,0,0,1.6-3.05,3.7,3.7,0,0,0-7.4,0A3.75,3.75,0,0,0,6,7.7a7.33,7.33,0,0,0-5,7.05V20.8H2V14.75A6.38,6.38,0,0,1,8.1,8.3a6.15,6.15,0,0,1,6.15,6.15V16.3h1V14.45a7.06,7.06,0,0,0-2.2-5.1,4.82,4.82,0,0,1,8.8,2.8v1.5h1v-1.5A6,6,0,0,0,18.8,6.55Zm-13.45-2a2.7,2.7,0,1,1,2.7,2.7A2.72,2.72,0,0,1,5.35,4.55ZM16.9,2a2.1,2.1,0,1,1,0,4.2,2.1,2.1,0,1,1,0-4.2Z"
      transform="translate(-0.95 -0.9)"
    />
  </svg>
);

export default Referral;
